/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelServicefail.ts                   *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/dispatch/servicefail";

export class AutogenModelServicefail<RowType extends ModelRow> extends Endpoint<RowType, RowServicefailFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowServicefail extends ModelRow<RowServicefailFields> {
	constructor(values?: Partial<RowServicefailFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowServicefailFields {
	activity_count: number;
	activity_start_date: Date;
	actual_arrival: Date;
	actual_departure: Date;
	actual_reefer_profile: string;
	add_empty_distance_occ: string;
	add_finance_charge: string;
	address: string;
	address1: string;
	address2: string;
	agency_id: string;
	agent_payee_id: string;
	all_vendors_enabled: string;
	allow_inc_in_frt: string;
	allow_relay: string;
	appointment_status_id: string;
	appt_contact_name: string;
	appt_required: string;
	auto_rate: string;
	auto_tax: string;
	autorate_status: string;
	available_template: number;
	average_bill: number;
	average_bill_c: string;
	average_bill_d: Date;
	average_bill_n: number;
	average_bill_r: number;
	average_pay_days: number;
	balance: number;
	balance_c: string;
	balance_d: Date;
	balance_n: number;
	balance_r: number;
	benchmark_ctg_uid: number;
	benchmark_tar_uid: number;
	bill_date: Date;
	bill_distance: number;
	bill_distance_um: string;
	bill_due_days: number;
	bill_format_flag: string;
	bill_template: number;
	bill_transfer_when: string;
	billed_loads: number;
	billing_empty_distance: number;
	billing_empty_distance_um: string;
	billing_loaded_distance: number;
	billing_loaded_distance_um: string;
	billing_user_id: string;
	bl_logo: string;
	bl_logo_name: string;
	blanket_buy_tariff_id: string;
	blanket_sell_tariff_id: string;
	blnum: string;
	bol_note: string;
	bol_received: string;
	bol_recv_date: Date;
	booking_no: string;
	booking_number: string;
	bridge_id: string;
	brk_qual_profile: string;
	broker_location_id: string;
	brokerage_filter: string;
	brokerage_workflow_id: string;
	business_hours: string;
	business_number: string;
	buy_tariff_id: string;
	carrier_scorecard_export_dt: Date;
	carrier_scorecard_exported: string;
	cases: number;
	category: string;
	caused_by_type: string;
	cbp_crossing_date: Date;
	cbp_crossing_location_id: string;
	cbp_crossing_reason: string;
	cbsa_crossing_date: Date;
	cbsa_crossing_location_id: string;
	cbsa_crossing_reason: string;
	cc_fuel_revenue: number;
	cc_fuel_revenue_c: string;
	cc_fuel_revenue_d: Date;
	cc_fuel_revenue_n: number;
	cc_fuel_revenue_r: number;
	cc_net_revenue: number;
	cc_net_revenue_c: string;
	cc_net_revenue_d: Date;
	cc_net_revenue_n: number;
	cc_net_revenue_r: number;
	cc_pro_nbr: string;
	cert_of_ins_date: Date;
	charge_detention: string;
	chassis_chargeby: string;
	chassis_freedays: number;
	chassis_rate: number;
	chassis_rate_c: string;
	chassis_rate_d: Date;
	chassis_rate_n: number;
	chassis_rate_r: number;
	city: string;
	city_id: number;
	city_name: string;
	cobroker_location_id: string;
	coll_thresh_pd1: number;
	coll_thresh_pd1_c: string;
	coll_thresh_pd1_d: Date;
	coll_thresh_pd1_n: number;
	coll_thresh_pd1_r: number;
	coll_thresh_pd2: number;
	coll_thresh_pd2_c: string;
	coll_thresh_pd2_d: Date;
	coll_thresh_pd2_n: number;
	coll_thresh_pd2_r: number;
	coll_thresh_pd3: number;
	coll_thresh_pd3_c: string;
	coll_thresh_pd3_d: Date;
	coll_thresh_pd3_n: number;
	coll_thresh_pd3_r: number;
	coll_thresh_pd4: number;
	coll_thresh_pd4_c: string;
	coll_thresh_pd4_d: Date;
	coll_thresh_pd4_n: number;
	coll_thresh_pd4_r: number;
	collection_method: string;
	collections_id: string;
	collections_ok: string;
	com_setpnt_temp: number;
	com_setpnt_temp_dt: Date;
	com_setpnt_temp_um: string;
	commitment_id: string;
	commodity: string;
	commodity_id: string;
	company_id: string;
	confidence_level: number;
	confirmed: string;
	consignee_refno: string;
	consignee_stop_id: string;
	contact_email: string;
	contact_name: string;
	container: string;
	container_chargeby: string;
	container_freedays: number;
	container_planned: string;
	container_rate: number;
	container_rate_c: string;
	container_rate_d: Date;
	container_rate_n: number;
	container_rate_r: number;
	container_type_id: string;
	contract_cbc: string;
	contract_ccc: string;
	contract_gbc: string;
	contract_gcc: string;
	contract_sbc: string;
	contract_scc: string;
	controlling_carrier_code: string;
	conversion_date: Date;
	copy_from_company: string;
	copy_from_order_id: string;
	copy_to_company: string;
	copy_to_order_id: string;
	cost_ctg_uid: number;
	cost_tar_uid: number;
	covered_template: number;
	cp_logo: string;
	cp_logo_name: string;
	credit_application: string;
	credit_check_date: Date;
	credit_limit: number;
	credit_limit_c: string;
	credit_limit_d: Date;
	credit_limit_n: number;
	credit_limit_r: number;
	credit_status: string;
	credit_warning_pct: number;
	ctg_uid: number;
	ctrl_party_id: string;
	cube: number;
	curr_movement_id: string;
	currency_type: string;
	cust_order_no: string;
	cust_requestor_load_id: string;
	cust_stmt_template: number;
	customer_id: string;
	d_and_b_code: string;
	d_and_b_date: Date;
	d_and_b_number: string;
	dat_loadboard_refid: string;
	days_between_calls: number;
	deadhead_target: number;
	declared_val: number;
	ded_last_fixed_cost_billdt: Date;
	dedicated_cycle: string;
	dedicated_revenue_code_id: string;
	dedicated_seg_alloc_code: string;
	dedicated_start_day: string;
	dedicated_template: number;
	def_move_type: string;
	def_rate_confirm_temp: number;
	default_match_id: string;
	delivered_template: number;
	departure_date_at: string;
	dim_height: string;
	dim_length: string;
	dim_surcharge: number;
	dim_surcharge_c: string;
	dim_surcharge_d: Date;
	dim_surcharge_n: number;
	dim_surcharge_r: number;
	dim_width: string;
	disable_automatic_tracking: string;
	dispatch_opt: string;
	dispatcher_user_id: string;
	display_eta: string;
	display_ysplit_stops: string;
	dist_from_prev: number;
	dist_from_prev_um: string;
	distance_method: string;
	distance_profile: string;
	distance_source: string;
	distance_type: string;
	dl_team_reqd: string;
	dot_number: string;
	dray_del_date: Date;
	dray_del_pay: number;
	dray_del_pay_c: string;
	dray_del_pay_d: Date;
	dray_del_pay_n: number;
	dray_del_pay_r: number;
	dray_del_payee: string;
	dray_del_xfer_dt: Date;
	dray_pu_date: Date;
	dray_pu_pay: number;
	dray_pu_pay_c: string;
	dray_pu_pay_d: Date;
	dray_pu_pay_n: number;
	dray_pu_pay_r: number;
	dray_pu_payee: string;
	dray_pu_xfer_dt: Date;
	driver_id: string;
	driver_load: string;
	driver_load_unload: string;
	dsp_comment: string;
	edi_code: string;
	edi_code_version: string;
	edi_element_id: string;
	edi_loc_code: string;
	edi_standard_code: string;
	eir1_no: string;
	eir2_no: string;
	empty_distance_charge_id: string;
	empty_distance_rate: number;
	enable_notifications: string;
	enforce_dep_dates: string;
	entered_date: Date;
	entered_user_id: string;
	equipment_type_id: string;
	equipment_type_options: string;
	est_tolls: number;
	est_tolls_c: string;
	est_tolls_d: Date;
	est_tolls_n: number;
	est_tolls_r: number;
	eta: Date;
	eta_distance: number;
	eta_late: string;
	eta_oor: string;
	excise_disable_update: string;
	excise_taxable: string;
	excisetax_total: number;
	excisetax_total_c: string;
	excisetax_total_d: Date;
	excisetax_total_n: number;
	excisetax_total_r: number;
	expected_close: Date;
	extend_rates: string;
	external_invoiceno: string;
	extra_deliveries: number;
	extra_pickups: number;
	factor_percent: number;
	factor_receivables: string;
	factoring_id: string;
	fak_profile_id: string;
	fault_of_carrier_or_driver: string;
	fleet_manager: string;
	floor_loaded_freight: string;
	force_assign: string;
	forwd_location_id: string;
	fourkites_customer_id: string;
	free_days: number;
	freight_charge: number;
	freight_charge_c: string;
	freight_charge_d: Date;
	freight_charge_n: number;
	freight_charge_r: number;
	fuel_amount: number;
	fuel_base_price: number;
	fuel_credit: string;
	fuel_method: string;
	fuel_percent: number;
	fuel_price_region: string;
	fuel_surcharge_id: string;
	fuel_surchg_enddt: Date;
	fuel_surchg_strtdt: Date;
	fuel_variance: number;
	global_detention: string;
	google_place_id: string;
	gp_exclude: string;
	gp_exported: Date;
	gp_imported: Date;
	grace_period: number;
	grouped_id: number;
	hazmat: string;
	hazmat_code: string;
	high_balance: number;
	high_balance_c: string;
	high_balance_d: Date;
	high_balance_n: number;
	high_balance_r: number;
	high_value: string;
	hold_reason: string;
	hub: number;
	ic_company_from: string;
	ic_company_id: string;
	ic_movement_from: string;
	ic_order_from: string;
	ic_stop_id: string;
	id: string;
	image_is_present: string;
	import_export: string;
	inbound_status: string;
	include_by_date: string;
	include_empty_distance: string;
	include_fuel_surcharge: string;
	include_split_point: string;
	integration_type: string;
	intelliset: string;
	invoice_processing_id: string;
	invoice_recv_date: Date;
	is_active: string;
	is_auto_tonu: string;
	is_autorate_dist: string;
	is_consignee: string;
	is_container: string;
	is_dedicated: string;
	is_distribution_center: string;
	is_drop_yard: string;
	is_geocoded: string;
	is_intercompany: string;
	is_local_mile: string;
	is_pallets_required: string;
	is_reportable: string;
	is_requested: string;
	is_shipper: string;
	is_tonu: string;
	is_trailer_pool_required: string;
	jag_carrier_id: string;
	jag_cost_rate_id: number;
	jaguar_id: number;
	last_bill_date: Date;
	last_fin_charge_dt: Date;
	last_pay_date: Date;
	last_ship_date: Date;
	late_eta_colorcode: string;
	late_route_status: string;
	latitude: number;
	ldport_location_id: string;
	linear_feet_avail: number;
	load_date: Date;
	loadboard: string;
	loadboard_last_refresh: Date;
	loadboard_post_movement_id: string;
	loadboard_posting_cancelled: string;
	location_id: string;
	location_name: string;
	lock_miles: string;
	longitude: number;
	ltl: string;
	macropoint_requestor_id: string;
	main_phone: string;
	manifest_fgp_uid: number;
	manifest_reg_uid: number;
	manual_exchange: string;
	mark_plan_id: string;
	markup_flat: number;
	markup_flat_c: string;
	markup_flat_d: Date;
	markup_flat_n: number;
	markup_flat_r: number;
	markup_percent: number;
	master_order_id: string;
	master_sequence: number;
	max_pay_percent: number;
	minutes_late: number;
	misc_bill_template: number;
	monthly_order_goal: number;
	motor_carrier_id: string;
	move_dist_from_preassign: number;
	move_dist_from_preassign_um: string;
	move_dist_from_previous: number;
	move_dist_from_previous_um: string;
	movement_id: string;
	movement_sequence: number;
	name: string;
	next_call_date: Date;
	next_rebill: string;
	next_rec_call: Date;
	nte_lp_num: string;
	nte_lp_qual: string;
	nxt_action_code_id: string;
	nxt_action_date: Date;
	on_hold: string;
	operational_status: string;
	operations_user: string;
	optimize: string;
	optiset: string;
	order_count: number;
	order_detail_at: string;
	order_id: string;
	order_length: number;
	order_mode: string;
	order_sequence: number;
	order_start_date: Date;
	order_type_id: string;
	order_value: number;
	order_value_c: string;
	order_value_d: Date;
	order_value_n: number;
	order_value_r: number;
	ordered_by: string;
	ordered_by_id: string;
	ordered_date: Date;
	ordered_method: string;
	orig_dest_rate_id: string;
	orig_sched_early: Date;
	orig_sched_late: Date;
	otherchargetotal: number;
	otherchargetotal_c: string;
	otherchargetotal_d: Date;
	otherchargetotal_n: number;
	otherchargetotal_r: number;
	override_arrive_early: Date;
	override_arrive_late: Date;
	override_max_city_radius: number;
	override_payee_id: string;
	override_posting_city_id: number;
	p44_profile_id: string;
	paid_loads: number;
	pallets_dropped: number;
	pallets_how_many: number;
	pallets_picked_up: number;
	pallets_required: string;
	pay_days_date: Date;
	pay_days_orders: number;
	pay_gross: number;
	pay_gross_c: string;
	pay_gross_d: Date;
	pay_gross_n: number;
	pay_gross_r: number;
	payee_id: string;
	payment_code_reviewed: string;
	pd0_alert: number;
	pd1_np_auto: string;
	pd1_sp_auto: string;
	pd1_sp_thresh: number;
	pd1_sp_thresh_c: string;
	pd1_sp_thresh_d: Date;
	pd1_sp_thresh_n: number;
	pd1_sp_thresh_r: number;
	pd2_np_auto: string;
	pd2_sp_auto: string;
	pd2_sp_thresh: number;
	pd2_sp_thresh_c: string;
	pd2_sp_thresh_d: Date;
	pd2_sp_thresh_n: number;
	pd2_sp_thresh_r: number;
	pd3_np_auto: string;
	pd3_sp_auto: string;
	pd3_sp_thresh: number;
	pd3_sp_thresh_c: string;
	pd3_sp_thresh_d: Date;
	pd3_sp_thresh_n: number;
	pd3_sp_thresh_r: number;
	pd4_np_auto: string;
	pd4_sp_auto: string;
	pd4_sp_thresh: number;
	pd4_sp_thresh_c: string;
	pd4_sp_thresh_d: Date;
	pd4_sp_thresh_n: number;
	pd4_sp_thresh_r: number;
	phone: string;
	pick_up_no: string;
	pieces: number;
	placard_required: string;
	planned_arrival_time: Date;
	planning_comment: string;
	plc_uid: number;
	pnn_callback: string;
	pnn_comment: string;
	pnn_comment2: string;
	pnn_loadboard_user_id: string;
	pnn_post_type: string;
	pnn_rate: number;
	pnn_rate_type: string;
	pnn_trailer_length: number;
	pnn_trailer_width: number;
	ponum: string;
	port: string;
	port_of_discharge: string;
	post_summary_dtl: string;
	potential: number;
	potential_c: string;
	potential_d: Date;
	potential_n: number;
	potential_r: number;
	preferred_vendors: string;
	preload_trailer_id: string;
	preloaded: string;
	prev_code: string;
	primary_agency: string;
	primary_commodity_id: string;
	primary_contact: string;
	primary_sort: string;
	primary_trailer_type: string;
	print_containers: string;
	prior_uncleared_stops: string;
	progress_template: number;
	projected_arrival: Date;
	prospect_type_id: string;
	pu_override_arrive_early: Date;
	pu_override_arrive_late: Date;
	quebec_number: string;
	quote_days_to_expire: number;
	rate: number;
	rate_currency_type: string;
	rate_dist_from_previous: number;
	rate_dist_from_previous_um: string;
	rate_id: number;
	rate_min_weight: number;
	rate_min_weight_um: string;
	rate_override_nmfc_code: string;
	rate_source: string;
	rate_type: string;
	rate_unit_desc: string;
	rate_units: number;
	ready_to_bill: string;
	reassign_profile_id: string;
	rec_call_days: number;
	recurring_order_id: string;
	refno: string;
	remarks: string;
	reply_transmitted: string;
	requested_service: string;
	requesting_company: string;
	require_tracking: string;
	required_vendor: string;
	resolution: string;
	return_temp: number;
	return_temp_dt: Date;
	return_temp_um: string;
	return_temp_var: number;
	return_temp_var_um: string;
	revenue: number;
	revenue_c: string;
	revenue_code_id: string;
	revenue_d: Date;
	revenue_n: number;
	revenue_r: number;
	revenue_share_method: string;
	revenue_start_date: Date;
	review_reqd: string;
	reviewed_by: string;
	reviewed_date: Date;
	round_trip: string;
	routing_guide_profile_id: string;
	sail_date: Date;
	sales_manager_id: string;
	sales_status_id: string;
	salesperson_id: string;
	sched_arrive_early: Date;
	sched_arrive_late: Date;
	seal: string;
	seal_number: string;
	search_city: string;
	search_state_id: string;
	search_zip_code: string;
	secondary_sort: string;
	seg_alloc_code: string;
	sell_tariff_id: string;
	service_date: Date;
	service_fail_cons: string;
	service_fail_drop: string;
	service_fail_pick: string;
	service_fail_ship: string;
	service_failures: string;
	service_failures_review: string;
	setpoint_temp: number;
	setpoint_temp_um: string;
	setpoint_var: number;
	setpoint_var_um: string;
	ship_status_to_edi: string;
	shipment_id: string;
	shipment_ident_type: string;
	shipper_stop_id: string;
	shipstatus2edi_dt: Date;
	showas_address: string;
	showas_address2: string;
	showas_city_id: number;
	showas_city_name: string;
	showas_location_id: string;
	showas_location_name: string;
	showas_state: string;
	showas_zip_code: string;
	sic_code: string;
	signed_for_name: string;
	smc3_profile_id: string;
	ss_location_id: string;
	"standard_code.company_id": string;
	"standard_code.description": string;
	"standard_code.element_id": string;
	"standard_code.standard_code": string;
	"standard_code.version": string;
	start_date: Date;
	state: string;
	state_id: string;
	status: string;
	stop_city_state: string;
	stop_id: string;
	stop_no: number;
	stop_type: string;
	subject_order_number: string;
	subject_order_status: string;
	subject_order_void_date: Date;
	summary_billing: string;
	summary_template: number;
	swap: string;
	tar_uid: number;
	target_profit: number;
	teams_required: string;
	temperature_max: number;
	temperature_max_um: string;
	temperature_min: number;
	temperature_min_um: string;
	temperature_um: string;
	tenfour_customer_id: string;
	terminal_id: string;
	toll_oc_exempt: string;
	total_charge: number;
	total_charge_c: string;
	total_charge_d: Date;
	total_charge_n: number;
	total_charge_r: number;
	totalcharge_and_excisetax: number;
	totalcharge_and_excisetax_c: string;
	totalcharge_and_excisetax_d: Date;
	totalcharge_and_excisetax_n: number;
	totalcharge_and_excisetax_r: number;
	tracking_hours_prior: number;
	tractor_id: string;
	tractor_type: string;
	trailer_id: string;
	trimble_place_id: string;
	txl_uid: number;
	type_of: string;
	use_local_mile: string;
	user_id: string;
	vessel: string;
	vessel_cutoff_date: Date;
	vm_part_update: string;
	voided_load_transmitted: string;
	voided_load_transmitted_dt: Date;
	volume: number;
	volume_um: string;
	waterfall_auto_route_guides: string;
	waterfall_lead_time: number;
	waterfall_notify_email: string;
	waterfall_process: string;
	website_url: string;
	weight: number;
	weight_um: string;
	wf_auto_renbill: string;
	wf_autobill: string;
	wf_bwop: string;
	wf_queue: number;
	xferred2billing: string;
	xferred2billing_dt: Date;
	zip_code: string;
	zone_id: string;
}

